export default __webpack_public_path__ + "static/media/bylc logo.2d61ff0a.jpg";